import React, { Component } from 'react';
import { FieldBase } from "easyui-core";

import { Col } from 'antd';
class AntWfComponent extends Component<{
    component: Component,
    form: any,
    field: FieldBase<any>
    formLayout: string
}> {
    // constructor(props) {
    //     super(props);
    // }
    components = {

    };
    render() {
        // const TagName = this.components[this.props.tag || 'AntInput'];
        const TagName: any = this.props.component
        const { getFieldDecorator } = this.props.form;
        return (
            <Col span={this.props.field.span}>
                <TagName form={this.props.form} field={this.props.field} formLayout={this.props.formLayout}></TagName>
            </Col>
        )
    }
}
export default AntWfComponent;